import { HttpClient } from 'api/http-client';
import { Goal } from './types';

class GoalsHttpClient extends HttpClient {
  public async getGoals(projectId: number): Promise<Goal[]> {
    return this.get(`/projects/${projectId}/goals`);
  }

  public async saveGoal(projectId: number, goal: Partial<Goal>): Promise<Goal> {
    if (goal.goalId) {
      return this.put(`/goals/${goal.goalId}`, { ...goal, projectId });
    }

    return this.post('/goals', {
      ...goal,
      projectId,
    });
  }

  public async deleteGoal(goalId: number): Promise<boolean> {
    return this.delete(`/goals/${goalId}`);
  }
}

export const GoalsApi = new GoalsHttpClient();
export * from './types';
